import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import { useAuth } from './contexts/AuthContext';

// Components
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import Dashboard from './components/Pages/Dashboard';
import ModuleList from './components/Pages/ModuleList';
import ModuleDetail from './components/Pages/ModuleDetail';
import Profile from './components/Pages/Profile';
import Resources from './components/Pages/Resources';
import AboutUs from './components/Pages/AboutUs';
import NVivoDashboard from './components/Pages/NVivoDashboard';
import StudyModule from './components/Pages/StudyModule';
import Login from './components/Pages/Login';
import Feedback from './components/Pages/Feedback';
import AdminDataExport from './components/Pages/AdminDataExport';
import FeedbackWidget from './components/FeedbackWidget/FeedbackWidget';
import PageFeedbackNotes from './components/PageFeedbackNotes/PageFeedbackNotes';

function AppShell({ currentUser, logout }) {
  const location = useLocation();
  const isStudyModuleRoute = location.pathname.startsWith('/study-module/');

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    const main = document.getElementById('main-content');
    if (main) main.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }, [location.pathname, location.search]);

  return (
    <div className={`app ${isStudyModuleRoute ? 'app--study-immersive' : ''}`}>
      <a href="#main-content" className="skip-link">Skip to main content</a>
      {!isStudyModuleRoute && (
        <Header user={currentUser} onLogout={logout} />
      )}
      <div className={`app-body ${isStudyModuleRoute ? 'app-body--immersive' : ''}`}>
        <main
          id="main-content"
          role="main"
          className={`main-content ${isStudyModuleRoute ? 'main-content--immersive' : ''}`}
        >
          <Routes>
            <Route path="/" element={<Dashboard user={currentUser} />} />
            <Route path="/modules" element={<ModuleList user={currentUser} />} />
            <Route path="/modules/:moduleId" element={<ModuleDetail user={currentUser} />} />
            <Route path="/profile" element={<Profile user={currentUser} />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/nvivo-dashboard" element={<NVivoDashboard />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/admin/data-export" element={<AdminDataExport />} />
            <Route path="/study-module/:moduleId" element={<StudyModule />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          {!isStudyModuleRoute && <Footer />}
        </main>
      </div>
      <FeedbackWidget user={currentUser} />
      <PageFeedbackNotes />
    </div>
  );
}

function App() {
  const { user: currentUser, isAuthenticated, loading, logout } = useAuth();
  if (loading) {
    return (
      <div className="app-loading" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', fontFamily: 'Arial, sans-serif' }}>
        Loading…
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <Router>
        <Routes>
          <Route path="/login" element={<><Login /><FeedbackWidget /></>} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    );
  }

  return (
    <Router>
      <Routes>
        {/* Main app with layout - study module opens as page, not modal */}
        <Route
          path="*"
          element={(
            <AppShell currentUser={currentUser} logout={logout} />
          )}
        />
      </Routes>
    </Router>
  );
}

export default App;

